
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function BookingSection() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    tipoServicio: '',
    tipoVehiculo: '',
    fechaViaje: '',
    horaViaje: '',
    numeroVuelo: '',
    aeropuerto: 'Ixtapa-Zihuatanejo',
    hotel: '',
    numeroPasajeros: '1',
    comentarios: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d3gok29evi82osegrfpg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          tipoServicio: '',
          tipoVehiculo: '',
          fechaViaje: '',
          horaViaje: '',
          numeroVuelo: '',
          aeropuerto: 'Ixtapa-Zihuatanejo',
          hotel: '',
          numeroPasajeros: '1',
          comentarios: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="reserva" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Reserva tu Transporte
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Completa el formulario para reservar tu traslado. Te contactaremos inmediatamente 
            para confirmar todos los detalles de tu viaje.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <form onSubmit={handleSubmit} className="bg-gray-50 rounded-2xl p-8" data-readdy-form id="reserva-transporte">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-2">
                      Nombre Completo *
                    </label>
                    <input
                      type="text"
                      id="nombre"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="Tu nombre completo"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="tu@email.com"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-2">
                      Teléfono/WhatsApp *
                    </label>
                    <input
                      type="tel"
                      id="telefono"
                      name="telefono"
                      value={formData.telefono}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="+52 755 123 4567"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="tipoServicio" className="block text-sm font-medium text-gray-700 mb-2">
                      Tipo de Servicio *
                    </label>
                    <select
                      id="tipoServicio"
                      name="tipoServicio"
                      value={formData.tipoServicio}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                    >
                      <option value="">Seleccionar servicio</option>
                      <option value="aeropuerto-hotel">Aeropuerto a Hotel</option>
                      <option value="hotel-aeropuerto">Hotel a Aeropuerto</option>
                      <option value="ida-vuelta">Ida y Vuelta</option>
                      <option value="personalizado">Servicio Personalizado</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="tipoVehiculo" className="block text-sm font-medium text-gray-700 mb-2">
                      Tipo de Vehículo *
                    </label>
                    <select
                      id="tipoVehiculo"
                      name="tipoVehiculo"
                      value={formData.tipoVehiculo}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus-ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                    >
                      <option value="">Seleccionar vehículo</option>
                      <option value="sedan">Sedán Ejecutivo (1-3 pax)</option>
                      <option value="van8">Van para 8 Pasajeros (4-8 pax)</option>
                      <option value="van">Van para 10 Pasajeros (7-10 pax)</option>
                      <option value="camioneta">Camioneta Grupo (13-15 pax)</option>
                    </select>
                  </div>
                  
                  <div>
                    <label htmlFor="numeroPasajeros" className="block text-sm font-medium text-gray-700 mb-2">
                      Número de Pasajeros *
                    </label>
                    <select
                      id="numeroPasajeros"
                      name="numeroPasajeros"
                      value={formData.numeroPasajeros}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus-ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                    >
                      {[...Array(15)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1} pasajero{i > 0 ? 's' : ''}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="fechaViaje" className="block text-sm font-medium text-gray-700 mb-2">
                      Fecha de Viaje *
                    </label>
                    <input
                      type="date"
                      id="fechaViaje"
                      name="fechaViaje"
                      value={formData.fechaViaje}
                      onChange={handleInputChange}
                      required
                      min={new Date().toISOString().split('T')[0]}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus-ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="horaViaje" className="block text-sm font-medium text-gray-700 mb-2">
                      Hora de Recogida *
                    </label>
                    <input
                      type="time"
                      id="horaViaje"
                      name="horaViaje"
                      value={formData.horaViaje}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus-ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="numeroVuelo" className="block text-sm font-medium text-gray-700 mb-2">
                      Número de Vuelo
                    </label>
                    <input
                      type="text"
                      id="numeroVuelo"
                      name="numeroVuelo"
                      value={formData.numeroVuelo}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus-ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="AM123, VB456, etc."
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="hotel" className="block text-sm font-medium text-gray-700 mb-2">
                      Hotel/Destino *
                    </label>
                    <input
                      type="text"
                      id="hotel"
                      name="hotel"
                      value={formData.hotel}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus-ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="Nombre del hotel o dirección"
                    />
                  </div>
                </div>

                <div className="mb-6">
                  <label htmlFor="comentarios" className="block text-sm font-medium text-gray-700 mb-2">
                    Comentarios Adicionales
                  </label>
                  <textarea
                    id="comentarios"
                    name="comentarios"
                    value={formData.comentarios}
                    onChange={handleInputChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus-ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                    placeholder="Información adicional, requerimientos especiales, etc. (máximo 500 caracteres)"
                  />
                  <div className="text-right text-xs text-gray-500 mt-1">
                    {formData.comentarios.length}/500 caracteres
                  </div>
                </div>

                {submitStatus === 'success' && (
                  <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                    <div className="flex items-center">
                      <i className="ri-check-circle-line mr-2"></i>
                      ¡Reserva enviada exitosamente! Te contactaremos pronto para confirmar los detalles.
                    </div>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                    <div className="flex items-center">
                      <i className="ri-error-warning-line mr-2"></i>
                      Hubo un error al enviar tu reserva. Por favor intenta nuevamente.
                    </div>
                  </div>
                )}

                <Button
                  type="submit"
                  size="lg"
                  disabled={isSubmitting}
                  className="w-full"
                  icon={isSubmitting ? <i className="ri-loader-4-line animate-spin"></i> : <i className="ri-send-plane-line"></i>}
                >
                  {isSubmitting ? 'Enviando Reserva...' : 'Enviar Reserva'}
                </Button>
              </form>
            </div>

            <div className="space-y-6">
              <div className="bg-blue-50 rounded-xl p-6">
                <h3 className="text-xl font-bold text-blue-900 mb-4">Contacto Directo</h3>
                <div className="space-y-4">
                  <a 
                    href="https://wa.me/5217551714622?text=Hola, quiero reservar un transporte"
                    className="flex items-center p-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-xl mr-3"></i>
                    <div>
                      <div className="font-medium">WhatsApp</div>
                      <div className="text-sm text-green-100">Respuesta inmediata</div>
                    </div>
                  </a>
                  
                  <a 
                    href="tel:+5217551714622"
                    className="flex items-center p-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer"
                  >
                    <i className="ri-phone-line text-xl mr-3"></i>
                    <div>
                      <div className="font-medium">+52 1 755 171 4622</div>
                      <div className="text-sm text-blue-100">Disponible 24/7</div>
                    </div>
                  </a>
                  
                  <a 
                    href="mailto:alfatransport.mx@gmail.com"
                    className="flex items-center p-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors cursor-pointer"
                  >
                    <i className="ri-mail-line text-xl mr-3"></i>
                    <div>
                      <div className="font-medium">Email</div>
                      <div className="text-sm text-teal-100">alfatransport.mx@gmail.com</div>
                    </div>
                  </a>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">¿Por qué Reservar?</h3>
                <ul className="space-y-3 text-sm text-gray-700">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    Confirmación inmediata
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    Precios transparentes
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    Seguimiento de vuelo
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    Conductor asignado
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    Soporte 24/7
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
